module.exports = __webpack_public_path__ + "img/star.61a02f91.svg";